import React, { useState } from 'react';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from 'components/ui/dropdown-menu';
import { Check } from 'lucide-react';
import { navMutedClass } from '../navIcons';
import { cn } from 'utils/cn';

export const NavLanguageMenu = ({
    languages = [
        { code: 'EN', label: 'English' },
        { code: 'RU', label: 'Русский' },
    ],
    selectedLanguage = 'EN',
    onSelectLanguage,
    compact = false,
    className,
}) => {
    const [open, setOpen] = useState(false);
    const active = languages.find((l) => l.code === selectedLanguage) || languages[0];

    return (
        <DropdownMenu open={open} onOpenChange={setOpen}>
            <DropdownMenuTrigger asChild>
                <button
                    type="button"
                    className={cn(
                        'inline-flex items-center justify-center gap-1.5 h-9 px-2.5 rounded-lg text-xs font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
                        navMutedClass,
                        'hover:text-[var(--primary-text-color)] hover:bg-[color:var(--dark-secondary-color)]/15',
                        open && 'bg-[color:var(--dark-secondary-color)]/15 text-[var(--primary-text-color)]',
                        className
                    )}
                    aria-label="Select language"
                >
                    <span className="font-semibold tracking-wide text-xs">{active?.code}</span>
                </button>
            </DropdownMenuTrigger>

            <DropdownMenuContent align="end" className="min-w-[4.5rem] p-1 shadow-lg">
                {languages.map((lang) => {
                    const isSelected = lang.code === active?.code;
                    return (
                        <DropdownMenuItem
                            key={lang.code}
                            onClick={() => onSelectLanguage && onSelectLanguage(lang.code)}
                            className={cn(
                                'flex items-center justify-between gap-2 px-2.5 py-1.5 rounded text-xs cursor-pointer',
                                isSelected ? 'bg-accent font-semibold text-foreground' : 'text-muted-foreground hover:text-foreground'
                            )}
                        >
                            <span className="font-bold tracking-wide text-foreground">{lang.code}</span>
                            {isSelected && <Check className="w-3.5 h-3.5 text-primary [html[data-theme=dark]_&]:text-[var(--primary-text-color)]" />}
                        </DropdownMenuItem>
                    );
                })}
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
